import { render, staticRenderFns } from "./UserScreen.vue?vue&type=template&id=a5f8e990&scoped=true&"
import script from "./UserScreen.vue?vue&type=script&lang=js&"
export * from "./UserScreen.vue?vue&type=script&lang=js&"
import style0 from "./UserScreen.vue?vue&type=style&index=0&id=a5f8e990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f8e990",
  null
  
)

export default component.exports